import { ref } from 'vue';

const getClients = () => {
    const clients_error = ref(null);
    const clients = ref(null);

    const loadClients = async (filters = null) => {
      try {
        var params = [];

        if (filters) {
            for (const filter of filters) {
              params.push(filter);
            }
        }

        let data = await fetch("/api/clients?" + new URLSearchParams(params));

        if (!data.ok) {
          throw Error("Can't load data");
        }

        clients.value = await data.json();

        // console.log('clients', clients.value);
      } catch (err) {
        clients_error.value = err.message;
      }
    };

    return { clients, clients_error, loadClients};
}

export default getClients;
